import React from "react";
import { FieldValues } from "react-hook-form";

import { ControllerDatePicker } from "./ControllerDatePicker";
import { FormInputWrapper } from "./FormInputWrapper";
import { FieldPathOfType } from "./formTypes";

interface IProps<TFieldValues extends FieldValues, TName extends FieldPathOfType<TFieldValues, Date>> {
    name: TName;
    label: string;
    required?: boolean;
    disabled?: boolean;
    disableFuture?: boolean;
}

/**
 * @deprecated Just directly use FormInputWrapper and ControllerDatePicker.
 */
export function FormDatePicker<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPathOfType<TFieldValues, Date> = FieldPathOfType<TFieldValues, Date>,
>({ name, label, required, disabled, disableFuture }: IProps<TFieldValues, TName>): React.ReactElement | null {
    return (
        <FormInputWrapper name={name} required={required} disabled={disabled} label={label}>
            <ControllerDatePicker
                name={name}
                controllerProps={{ rules: { required } }}
                disabled={disabled}
                disableFuture={disableFuture}
            />
        </FormInputWrapper>
    );
}
